import PropTypes from 'prop-types';
import cn from 'classnames';
import SimpleCheckbox from '../common/SimpleCheckbox';
import styles from './Filters.module.scss';
import { InfoTitle } from '../common/InfoTooltip';

export function CheckboxFilter(props) {
  const { name, onChange, disabled, info, checked } = props;

  return (
    <InfoTitle content={info} disabled={!info}>
      <div className={cn(styles.filter, styles.checkboxFilter, disabled ? styles.disabled : '')}>
        <label>
          <SimpleCheckbox checked={checked} onChange={onChange} disabled={disabled} label={name} value={name} />
        </label>
      </div>
    </InfoTitle>
  );
}

CheckboxFilter.defaultProps = {
  disabled: false,
};

CheckboxFilter.propTypes = {
  name: PropTypes.string.isRequired,
  info: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};
